import { Dashboard, PeopleAlt } from "mosaic-react-icons";
const navigation = [
    {
        name: "Organizations",
        to: "/settings/organizations",
        exact: true,
        icon: Dashboard,
    },
    {
        name: "Projects",
        to: "/settings/projects",
        exact: true,
        icon: Dashboard,
    },
    {
        name: "Users",
        to: "/settings/users",
        exact: true,
        icon: PeopleAlt,
    },
];

export const manageNavigation = (tabs) => {
    return [...navigation, ...tabs];
};
